module.exports = __webpack_public_path__ + "static/media/Erfan.5d477a81.JPG";